module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.06d9d214.svg";